import React, { useEffect, useState } from "react";
import { Table, Checkbox, Button, Spin } from "antd";
import AttendanceInput from "Components/Form/AttendanceInput";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import LoadingSpinner from "Components/UI/LoadingSpinner";

const MonthlyAttendanceTable = ({
  workingDays,
  employeeAttendanceList,
  dispatch,
  daysInfo,
  isLoading
}) => {
  const [isMount, setIsMount] = useState(false);
  const useFormData = useFormContext();
  const { register, setValue, getValues, watch } = useFormData;
  const [expandedRows, setExpandedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);


  const columns = [
    // {
    //   title: "Present",
    //   dataIndex: "isPresent",
    //   render: (_, record) => (
    //     <Checkbox
    //       {...register(`isPresent[${record.employeeCode}]`)}
    //       checked={watch(`isPresent[${record.employeeCode}]`)}
    //       onChange={(e) =>
    //         dispatch({
    //           type: "MARK_PRESENT",
    //           data: {
    //             status: e.target.checked,
    //             id: record.employeeCode,
    //           },
    //         })
    //       }
    //     />
    //   ),
    // },
    {
      title: (
        <Checkbox
          checked={selectAll}
          //   onChange={(e) => handleSelectAll(e.target.checked)}
          onChange={(e) => {
            setSelectAll(e.target.checked);
            dispatch({
              type: "MARK_ALL",
              data: {
                status: e.target.checked,
              },
            });
          }}
        ></Checkbox>
      ),
      dataIndex: "isPresent",
      render: (_, record) => (
        <Checkbox
          {...register(`isPresent[${record.employeeCode}]`)}
          checked={watch(`isPresent[${record.employeeCode}]`)}
          onChange={(e) =>
            dispatch({
              type: "MARK_PRESENT",
              data: {
                status: e.target.checked,
                id: record.employeeCode,
              },
            })
          }
        />
      ),
    },
    {
      title: "Emp Name",
      dataIndex: "employeeDetails",
      fixed: "left",
      render: (_, record) => (
        <div >
          {record.fullName}&nbsp;
          <Button
            type="link"
            icon={<i className="fa fa-solid fa-info"></i>}
            onClick={() => toggleRowExpansion(record.employeeCode)}
          />
        </div>
      ),
    },
    ...daysInfo.map((day, index) => ({
      title: (
        <div
          className={
            day.isPublicHoliday
              ? "atten-public-holiday"
              : day.isWeekEnd
              ? "weekend"
              : ""
          }
        >
          {day.date} <br />
          <span>{day.dayName}</span>
        </div>
      ),
      dataIndex: `day_${index}`,
      render: (_, record) => (
        <AttendanceInput
          row={index}
          employeeCode={record.employeeCode}
          showDetails={expandedRows.includes(record.employeeCode)}
          useFormData={useFormData}
          dispatch={dispatch}
          key={`attendance-input-${index}`}
        />
      ),
    })),
  ];

  const dataSource = employeeAttendanceList?.map((employee) => ({
    key: employee.employeeCode,
    employeeCode: employee.employeeCode,
    fullName: employee.fullName,
  }));

  // Handle row expansion toggle
  const toggleRowExpansion = (employeeCode) => {
    setExpandedRows((prev) =>
      prev.includes(employeeCode)
        ? prev.filter((code) => code !== employeeCode)
        : [...prev, employeeCode]
    );
  };

  if (isLoading) return <LoadingSpinner />;
  return (
    <Spin spinning={isLoading}>
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        expandable={{
          expandedRowKeys: expandedRows,
          onExpand: (expanded, record) =>
            toggleRowExpansion(record.employeeCode),
        }}
        rowClassName={(record) =>
          expandedRows.includes(record.employeeCode) ? "expanded-row" : ""
        }
      />
    </Spin>
  );
};

MonthlyAttendanceTable.propTypes = {
  workingDays: PropTypes.number.isRequired,
  employeeAttendanceList: PropTypes.arrayOf(
    PropTypes.shape({
      employeeCode: PropTypes.number.isRequired,
      fullName: PropTypes.string.isRequired,
    })
  ).isRequired,
  dispatch: PropTypes.func.isRequired,
  daysInfo: PropTypes.array.isRequired,
  isLoading : PropTypes.bool.isRequired
};

export default MonthlyAttendanceTable;
